module.exports = __webpack_public_path__ + "36543310091c45982ada9a10824e9f10.svg";